import React from "react";
import "./App.css";
import "@mantine/core/styles.css";
import { MantineProvider } from "@mantine/core";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import EventPage from "./components/EventPage/eventPage";
import CheckoutPage from "./components/Checkout/checkout";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const stripe = loadStripe("pk_test_51J4eZ6LPl2IMreEUJ2cJ6eAm2YmEvcSJZx8bSHXsMSh1MeP0oHZZg2LwvZgsSs0yh1S7AnUyAWXXvxybcy7qOUV800QupybYOg");

function App() {
  return (
    <MantineProvider>
      <Router>
        <Routes>
          <Route exact path="/" Component={EventPage} />
          <Route
            exact
            path="/checkout-page"
            element={
              <Elements stripe={stripe}>
                <CheckoutPage />
              </Elements>
            }
          />
        </Routes>
      </Router>
    </MantineProvider>
  );
}

export default App;
